import { Star, Quote } from "lucide-react";

export function Stars({ n, size = "h-4 w-4" }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`${size} ${i <= n ? "text-[#ff6b00] fill-[#ff6b00]" : "text-slate-700"}`} />
      ))}
    </div>
  );
}

export default function ReviewCard({ review, compact }) {
  return (
    <div className={`cj-card ${compact ? "p-4" : "p-5"} relative`} data-testid={`review-card-${review.id}`}>
      <Quote className="absolute top-4 right-4 h-5 w-5 text-[#ff6b00]/30" />
      <Stars n={review.rating} />
      {review.quote && <p className={`mt-3 text-slate-200 leading-relaxed ${compact ? "text-sm" : "text-base"}`}>“{review.quote}”</p>}
      <div className="mt-3 font-display uppercase font-bold text-sm text-slate-100">{review.customer_name}</div>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-0.5">
        {[review.vehicle_label, review.service_name].filter(Boolean).join(" · ")}
      </div>
    </div>
  );
}
